import { fetchData, urls } from '@internal/backstage-plugin-dh-dock-shared-common';

const ADR_CACHE_TTL_MS = 5 * 60 * 1000;

type CacheEntry<T> = {
  expiresAt: number;
  value: T;
};

const adrListCache = new Map<string, CacheEntry<any>>();
const adrContentCache = new Map<string, CacheEntry<any>>();
const inFlightAdrListRequests = new Map<string, Promise<any>>();
const inFlightAdrContentRequests = new Map<string, Promise<any>>();

async function readThroughCache<T>(
  cache: Map<string, CacheEntry<T>>,
  inFlightRequests: Map<string, Promise<T>>,
  key: string,
  loader: () => Promise<T>,
): Promise<T> {
  const cached = cache.get(key);
  if (cached && cached.expiresAt > Date.now()) {
    return cached.value;
  }

  const inFlight = inFlightRequests.get(key);
  if (inFlight) {
    return inFlight;
  }

  const request = loader()
    .then(value => {
      cache.set(key, {
        value,
        expiresAt: Date.now() + ADR_CACHE_TTL_MS,
      });
      return value;
    })
    .finally(() => {
      inFlightRequests.delete(key);
    });

  inFlightRequests.set(key, request);
  return request;
}

export const getAdrListByUrl = async (url: string) => {
  return readThroughCache(adrListCache, inFlightAdrListRequests, url, async () => {
    return fetchData(`${urls.getMultiAdrList}${url}`);
  });
};

export const getAdrContentBytitle = async (title: string) => {
  return readThroughCache(adrContentCache, inFlightAdrContentRequests, title, async () => {
    return fetchData(`${urls.getAdrContentByName}${title}`);
  });
};

